import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { unknownUrlGuard } from '@common/auth/services/space.guards';

/**
 * The root catch-all (kz2 M12 N-2): a typed URL no route knows (`/automations`, `/nope`) sends a
 * signed-in person to their home (`roleHomeUrl`) and anyone else to the login — never a blank `/`
 * with NG04002.
 *
 * Its own module, imported LAST in AppModule: the root routes are `productRoutes` (AppRoutingModule)
 * followed by every eager module's `forChild` routes (AuthModule's /login, /signup, /walkthrough…;
 * Tags; Tenants) in import order, and a `**` shadows everything after it. That is what the old
 * `** → /welcome` in product.routes.ts broke, and why it was commented out.
 */
export const fallbackRoutes: Routes = [{ path: '**', canActivate: [unknownUrlGuard], children: [] }];

@NgModule({
  imports: [RouterModule.forChild(fallbackRoutes)],
  exports: [RouterModule],
})
export class AppFallbackRoutingModule {}
